export default function (target, type) {
  return target instanceof type;
}
